export default "__VITE_ASSET__ZEH6QU42__"